// components/PlanosPagamento/ConfiguracaoMetodosPagamento.jsx
import React from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  FormControlLabel,
  Switch,
  TextField,
  Card,
  CardContent,
  Typography,
  Box,
  Alert
} from '@mui/material';

const METODOS_PAGAMENTO = [
  { key: 'MPESA', label: 'M-PESA' },
  { key: 'EMOLA', label: 'E-MOLA' },
  { key: 'BIM', label: 'Millennium BIM' },
  { key: 'BCI', label: 'BCI' },
  { key: 'MOZABANK', label: 'MOZABANK' }
];

const ConfiguracaoMetodosPagamento = ({ formData, onUpdateForm }) => {
  const handleMetodoChange = (metodo) => (event) => {
    const metodosAtualizados = {
      ...formData.metodosDisponiveisJSON,
      [metodo]: event.target.checked
    };
    onUpdateForm({ metodosDisponiveisJSON: metodosAtualizados });
  };

  return (
    <Box>
      {formData.tipo === 'INDIVIDUAL' && (
        <Alert severity="info" sx={{ mb: 3 }}>
          Os métodos de pagamento são herdados do plano base.
          Alterações aqui afetarão apenas este plano individual.
        </Alert>
      )}

      <Typography variant="h6" gutterBottom>
        Métodos de Pagamento Disponíveis
        {formData.tipo === 'BASE' ? ' (Plano Base)' : ''}
      </Typography>

      {formData.tipo === 'INDIVIDUAL' && formData.planoBase && (
        <Typography variant="caption" color="text.secondary" display="block" gutterBottom>
          Plano Base: {formData.planoBase.descricao}
        </Typography>
      )}

      <Grid container spacing={3}>
        {METODOS_PAGAMENTO.map((metodo) => (
          <Grid item xs={12} key={metodo.key}>
            <Card variant="outlined">
              <CardContent>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs={12} md={4}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={formData.metodosDisponiveisJSON[metodo.key] || false}
                          onChange={handleMetodoChange(metodo.key)}
                          color="primary"
                        />
                      }
                      label={metodo.label}
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

ConfiguracaoMetodosPagamento.propTypes = {
  formData: PropTypes.shape({
    metodosDisponiveisJSON: PropTypes.object,
    tipo: PropTypes.oneOf(['BASE', 'INDIVIDUAL']).isRequired,
    planoBase: PropTypes.shape({
      id: PropTypes.number,
      descricao: PropTypes.string
    })
  }).isRequired,
  onUpdateForm: PropTypes.func.isRequired
};

export default ConfiguracaoMetodosPagamento;
